export const getRecaptchaToken = (siteKey: string, opt?: { action?: string }) =>
  new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
            .execute(siteKey, opt)
            .then(resolve)
            .catch(reject);
    });
  });
